export default "__VITE_ASSET__CfRwiEuj__"